/**
 * DD-LINE-ID-CLEANUP-001 G2 — mutation map keyed by persisted line_key only.
 *
 * Identity: `${requestId}:${lineKey}` — never sku.
 * Display sku lives on the subject seed / ResolvedSubject.sku, not in this map key.
 */

import type { SubjectMutation } from '@/lib/dd-queue/types/subjectMutation'

/** Build the Pinia mutation-map identity key. */
export function subjectMutationKey(requestId: string, lineKey: string): string {
  return `${requestId}:${lineKey}`
}

/** Read overlay by identity lineKey (empty object when absent). */
export function readSubjectMutation(
  mutations: Record<string, SubjectMutation>,
  requestId: string,
  lineKey: string
): SubjectMutation {
  return mutations[subjectMutationKey(requestId, lineKey)] ?? {}
}

/** Write overlay by identity lineKey (replaces that slot only). */
export function writeSubjectMutation(
  mutations: Record<string, SubjectMutation>,
  requestId: string,
  lineKey: string,
  value: SubjectMutation
): Record<string, SubjectMutation> {
  return {
    ...mutations,
    [subjectMutationKey(requestId, lineKey)]: value,
  }
}
